/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import { unstable } from '@broadleaf/admin-components';

const { SVG, Tooltip } = unstable;

const WarningTip = ({ baseColor = 'yellow', message }) => {
  return (
    <Tooltip
      baseColor={baseColor}
      className="tw-mr-2"
      controlTag={ControlTag}
      message={message}
      placement="bottom"
    />
  );
};

const ControlTag = ({ baseColor, label, toggleTooltip }) => {
  return (
    <div
      className="tw-mr-2 tw-cursor-pointer"
      onClick={() => {
        toggleTooltip();
      }}
      title={label}
    >
      <SVG
        className={`tw-h-5 tw-w-5 tw-text-${baseColor}-600 hover:tw-text-${baseColor}-700 tw-fill-current`}
        name="exclamation-solid"
      />
    </div>
  );
};

export default WarningTip;
export { WarningTip };
